<template>
  <component
    :is="computedInputType"
    :class="computedClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ computedValue }}
  </component>
</template>

<script>
import { EmdInput } from 'emerald-vue/src/components'
import masker from 'vue-the-mask/src/masker'
import tokens from 'vue-the-mask/src/tokens'

export default {
  name: 'InputDisabled',
  components: {
    EmdInput
  },

  computed: {
    computedValue () {
      return this.$attrs.mask
        ? masker(this.$attrs?.value, this.$attrs.mask, true, tokens)
        : this.$attrs?.value
    },

    computedInputType () {
      return this.$attrs?.disabled ? 'p' : 'emd-input'
    },

    computedClass () {
      return this.$attrs?.disabled ? 'emd-input _disabled' : ''
    }
  }
}
</script>
